import { Injectable } from '@angular/core';
import { environment } from '../../../../environments/environment';
import { HttpClient, HttpHeaders, HttpParams } from '@angular/common/http';
import { CustomerService } from '../customer.service';

@Injectable({
  providedIn: 'root'
})
export class BatchService {

  private endpointPrefix = environment.apiUrl;
  constructor(private http: HttpClient, private customerService: CustomerService) { }

  public createBatch(payload: any, customerId: number | undefined) {
    if (customerId) {
      return this.http.post(`${this.endpointPrefix}/reconciliation-batches/customer/${customerId}/test/multiple`, payload, { reportProgress: true, observe: 'events' });
    }
    return this.http.post(`${this.endpointPrefix}/reconciliation-batches/multiple`, payload, { reportProgress: true, observe: 'events' });
  }

  createReconciliationBatchWithMultipleSource(payload: any, customerId: number | undefined) {
    if (customerId) {
      return this.http.post(`${this.endpointPrefix}/reconciliation-batches/customer/${customerId}/test/create-multiple`, payload, { reportProgress: true, observe: 'events' });
    }
    return this.http.post(`${this.endpointPrefix}/reconciliation-batches/create-multiple`, payload, { reportProgress: true, observe: 'events' });
  }

  public getAllbatches(page: number, size: number, customerId: number | undefined, filters?: any) {
    let params = new HttpParams()
      .set('page', page)
      .set('size', size);

    if (filters) {
      if (filters.name) {
        params = params.set('name', filters.name);
      }
      if (filters.dateStart) {
        params = params.set('dateStart', filters.dateStart);
      }
      if (filters.dateEnd) {
        params = params.set('dateEnd', filters.dateEnd);
      }
      if (filters.operationTypeCode) {
        params = params.set('operationTypeCode', filters.operationTypeCode
        );
      }
    }
    if (customerId) {
      params = params.set('customerId', customerId);
    }
    if (!this.customerService.getIsJubooAgent()) {
      return this.http.get(`${this.endpointPrefix}/reconciliation-batches`, { params });
    }
    else {
      let Id = customerId || 0
      return this.http.get(
        `${this.endpointPrefix}/reconciliation-batches/customer/${Id}/test-sources`, { params }
      );
    }
  }

  public getBatchById(id: number) {
    return this.http.get(`${this.endpointPrefix}/reconciliation-batches/${id}`);
  }

  public getExternalSourceAndInternalSourceBatch(ids: number[]) {
    let params = new HttpParams();
    ids.forEach(id => {
      params = params.append('batchId', id.toString());
    });
    return this.http.get(`${this.endpointPrefix}/reconciliation-batches/source-types`, { params });
  }

  public replayReconciliationBatch(batchId: number) {
    return this.http.patch(`${this.endpointPrefix}/reconciliation-batches/${batchId}/replay`, {});
  }

  public getTransactionsForBatch(batchId: number) {
    return this.http.get(`${this.endpointPrefix}/reconciliation-batches/${batchId}/bundle-transactions`);
  }

  public updateBundleTransactions(batchId: number, modifications: any[]) {
    return this.http.patch(`${this.endpointPrefix}/reconciliation-batches/${batchId}/bundle-transactions`, modifications);
  }

  replayBundle(batchId: number) {
    return this.http.patch(`${this.endpointPrefix}/reconciliation-batches/${batchId}/replay-reconciliations`, {});
  }

  getManualFieldOverrideInfos(batchId: number) {
    return this.http.get(`${this.endpointPrefix}/reconciliation-batches/${batchId}/check-informations`);
  }

  public getBatchesByOperationType(operationTypeIds: number[], customerId: number | undefined) {
    let params = new HttpParams();
    if (operationTypeIds && operationTypeIds.length > 0) {
      operationTypeIds.forEach(id => {
        params = params.append('operationTypeId', id.toString());
      });
    }

    if (customerId) {
      params = params.append('customerId', customerId.toString());
    }
    return this.http.get(`${this.endpointPrefix}/operation-types/reconciliation-batches`, { params });
  }

  getReconciliationBatchOptions(customerId: number | undefined) {
    if (!this.customerService.getIsJubooAgent()) {
      return this.http.get(`${this.endpointPrefix}/reconciliation-batches/option`,);
    }
    else {
      let Id = customerId || 0
      return this.http.get(`${this.endpointPrefix}/reconciliation-batches/option?customerId=${Id}`)
    }
  }

}
